import React from "react";

import FieldHelpTooltip from "./FieldHelpTooltip";

interface FormFieldLabelProps {
  label: string;
  helpText?: string;
  className?: string;
  component?: keyof JSX.IntrinsicElements;
}

export default function FormFieldLabel({
  label,
  helpText,
  className = "form-label",
  component: Component = "label",
}: FormFieldLabelProps) {
  return (
    <Component className={className}>
      <span>{label}</span>
      {helpText && <FieldHelpTooltip text={helpText} />}
    </Component>
  );
}
